import React from 'react';
import { View, Text } from 'react-native';
import { DLOPercentageOfWeeklyDSDVolumeTable } from '../../../components/Tables';
import NonDSDVolumeZoneDistributionByDay from '../../../components/Tables/NonDSDVolumeZoneDistributionByDay';
import { transformDailyPercentageData } from '../utils/dataTransformers';

interface NONDSDVolumeTablesProps {
  dloLocationSetting: any;
  styles: any;
}

const NONDSDVolumeTables: React.FC<NONDSDVolumeTablesProps> = ({
  dloLocationSetting,
  styles
}) => {
  return (
    <>
      {/* DLOPercentageOfWeeklyDSDVolumeTable - NON DSD */}
      {/* Commenting out Weekly NONDSD Volume section in Location & Schedule settings */}
      {/* {dloLocationSetting.nonDsdDailyLoading ? (
        <View style={styles.tableLoaderContainer}>
          <Text style={styles.tableLoadingText}>Loading Percentage of Weekly NON DSD Volume...</Text>
        </View>
      ) : (
        <DLOPercentageOfWeeklyDSDVolumeTable
          data={transformDailyPercentageData(dloLocationSetting.NONDSDDailyPercentage?.data || [])}
          onSave={() => console.log('Non-DSD Percentage table save action')}
          onRowSave={(rowId) => console.log('Non-DSD Percentage row save action:', rowId)}
          onRowClear={(rowId) => console.log('Non-DSD Percentage row clear action:', rowId)}
          onRowDelete={(rowId) => console.log('Non-DSD Percentage row delete action:', rowId)}
          headerTitle="PERCENTAGE OF WEEKLY NON DSD VOLUME"
          type="NON-DSD"
          style={styles.percentageTable}
        />
      )} */}

      {/* NonDSDVolumeZoneDistributionByDay - NON DSD */}
      {dloLocationSetting.nonDsdLoading ? (
        <View style={styles.tableLoaderContainer}>
          <Text style={styles.tableLoadingText}>Loading NON-DSD Zone Volume Distribution By Day...</Text>
        </View>
      ) : (
        <NonDSDVolumeZoneDistributionByDay
          data={dloLocationSetting.NONDSDVolumeDistributionByDay?.data || []}
          onAddZone={() => console.log('Add NON-DSD zone action')}
          onSave={() => console.log('NON-DSD Zone Volume table save action')}
          title="NON DSD ZONE VOLUME DISTRIBUTION BY DAY"
          type="NON-DSD"
          context="location-settings"
          style={styles.zoneDistributionTable}
        />
      )}
    </>
  );
};

export default NONDSDVolumeTables;
